import Vue from 'vue';
import Config from '@/config';
import {sortByAuth} from "@/utils/group";
import {date2Iso} from "@/utils/date";
import {sortAllContextsChildren} from "@/utils/area";

const mutations = {
    /*topicItem: (state, payload) => {
        console.log("MUTATION topic/item", payload);
        if (!payload?.tasks?.items?.length) return;


    },*/
    topicCreate: (state, payload) => {
        console.log("MUTATION topic/create", payload);

        // after creation - call this
        payload.mutation = "topicAppend";

        // after creation - broadcast to subscribers of this
        /*const broadcast = [{
            entity: "group",
            auth: payload.groupAuth,
        }];
        if (payload.topicAuth) broadcast.push({
            entity: "topic",
            auth: payload.topicAuth,
        });
        payload.broadcast = broadcast;
        console.log("broadcast", broadcast);*/
    },
    topicAppend: (state, payload) => {
        console.log("MUTATION topic/append", payload);
        const topic = payload?.topicAppend?.item;
        if (!topic) return;

        const topicExists = state.session.area.topics.find(el => el.auth === topic.auth);
        console.log("topicExists", topicExists);
        if (topicExists) return;

        const group = state.session.area.groups.find(el => el.id === topic.groupId);
        console.log("groupExists", group);
        if (!group) return;

        // append topic to area
        state.session.area.topics.unshift(topic);

        // append topic to group children
        if (!group.children) Vue.set(group, "children", []);
        group.children?.unshift(topic);
        group.topicSort?.unshift(topic.auth);
        /*if ( payload?.topicPrepend ) {
            group.children.unshift(topic);
            group.topicSort.unshift(topic.auth);
        }
        else {
            group.children.push(topic);
            group.topicSort.push(topic);
        }*/

        // append topic to context-tasks
        if (group.contextId === state.page.context.item?.contextId) {
            if (!state.page.tasks.topics) state.page.tasks.topics = [];
            state.page.tasks.topics.push(topic);
        }

        // todo update picks?
    },
    topicUpdate: (state, payload) => {
        console.log("MUTATION topic/update", payload);

        const auth = payload.topicAuth || payload.topicUpdate?.item?.auth;
        if (!auth) return;

        const params = payload?.params || payload.topicUpdate?.item;
        if (!params) return;

        const update = (item) => {
            Object.keys(payload.params).forEach(key => {
                Vue.set(item, key, payload.params[key]);
                //console.log("Topic."+key+": "+payload.params[key]);
            });
        }

        // update item in session
        const items = state.session.area.topics;
        let item;
        if (items?.length) {
            item = items.find(el => el.auth === auth);
            if (item) update(item);
        }

        // update item in context
        if (state.page.context.topic && state.page.context.topic.auth === auth) update(state.page.context.topic);
    },
    topicAssign: (state, payload) => {
        console.log("MUTATION topic/assign", payload);
        if (!payload?.topicAuth) return;
        //if (!payload?.assigneeAuth&&!payload?.ownerAuth) return;

        const auth = payload.topicAuth;
        const userAuth = payload.assigneeAuth || payload.ownerAuth;

        let userId = null;
        if (userAuth) {
            const user = state.session.area.users.find(el => el.id === userAuth);
            //console.log("USER FOUND", user);
            if (user) userId = user.id;
            else return;
        }

        let property;
        if (typeof payload.ownerAuth !== "undefined") property = "ownerId";
        else property = "userId";

        // update item in a area
        const items = state.session.area.topics;
        let item;
        if (items?.length) {
            item = items.find(el => el.auth === auth);
            if (item) item[property] = userId;
        }

        // update item in context
        if (state.page.context.topic?.auth === auth) state.page.context.topic[property] = userId;

        // broadcast to subscribers of this
        if (item) {
            const broadcast = [{
                entity: "group",
                auth: item.groupAuth,
            }];
            payload.broadcast = broadcast;
            console.log("broadcast", broadcast);
        }
    },
    topicDelete: (state, payload) => {
        console.log("MUTATION topic/delete", payload);

        // response mutation
        if (payload.topicDelete?.item?.contextId) {
            payload.contextId = payload.topicDelete?.item?.contextId;
        }

        // delete from area
        const auth = payload.topicAuth || payload.contextId;
        const topic = state.session.area.topics?.find(el => el.auth === auth);
        let group;
        if (topic) {

            const index = state.session.area.topics.findIndex(el => el.auth === auth);
            if (index >= 0) state.session.area.topics.splice(index, 1);

            // delete from parent group children
            group = state.session.area.groups?.find(el => el.auth === topic.groupAuth);
            if (group?.children) {
                const index = group.children.findIndex(el => el.auth === auth);
                if (index >= 0) group.children.splice(index, 1);
            }

            // delete from context-tasks
            if (group.contextId === state.page.context.item?.contextId) {
                if (state.page.tasks.topics?.length) {
                    const index = state.page.tasks.topics.findIndex(el => el.auth === auth);
                    if (index >= 0) state.page.tasks.topics.splice(index, 1);
                }
            }
        }

        // clear context
        if (state.page.context.topic?.auth === auth) {
            state.page.context.topic = null;
            state.page.tasks.items = null;
        }

        // broadcast to subscribers of this
        if (topic) {
            const broadcast = [{
                entity: "group",
                auth: topic.groupAuth,
            }];
            payload.broadcast = broadcast;
            console.log("broadcast", broadcast);
        }
    },
    topicFromTask: (state, payload) => {
        console.log("MUTATION topic/fromTask", payload);

        mutations.topicAppend(state, payload);
    },
    topicArchive: (state, payload) => {
        console.log("MUTATION topic/archive", payload);
        if (!payload?.params) return;

        const params = payload.params;
        if (params.isArchived) {
            params.archivedAt = date2Iso(new Date());
            //params._isArchived = true;
            //params.isFav = false;
        } else {
            params.archivedAt = null;
            //params._isArchived = false;
        }

        mutations.topicUpdate(state, payload);
    },
    topicTagSort: (state, payload) => {
        console.log("MUTATION topic/tagSort", payload);

        const topic = state.session.area.topics.find(el => el.auth === payload.topicAuth);
        if (!topic) return;

        sortByAuth(topic.children, payload.tagSort);
        //console.log("AFTER sort", group.children.map(c=>c.auth));

        Vue.set(topic, "tagSort", payload.tagSort);
        console.log("payload.tagSort", payload.tagSort);

        sortAllContextsChildren(state.session.area, state.session.user);

        // broadcast to subscribers of this
        const broadcast = [{
            entity: "topic",
            auth: topic.auth,
        }];
        payload.broadcast = broadcast;
        console.log("broadcast", broadcast);
    },
};

export default mutations;
